var removeBlanks = function (content) {
    var temp = '';
    for (var i = 0; i < content.length; i++) {
        var c = content.charAt(i);
        if (c !== ' ') {
            temp += c;
        }
    }
    return temp;
};
var getCookie = function (name) {
    var cookie = document.cookie;
    var str = removeBlanks(cookie);
    var pairs = str.split(';');
    for (var i = 0; i < pairs.length; i++) {
        var pairSplit = pairs[i].split('=');
        if (pairSplit.length > 1 && pairSplit[0] === name) {
            return pairSplit[1];
        }
    }
    return '';
};




module.exports.getCookie = getCookie;
module.exports.removeBlanks = removeBlanks;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/utils/index.js